module.exports = __webpack_public_path__ + "static/media/ellipse.67619716.svg";